import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';

export const useDeleteOrder = ({
    onSuccessCb,
    searchDraft,
}: {
    onSuccessCb: () => void;
    searchDraft: string;
}) => {
    const queryClient = useQueryClient();

    const trimmed = (searchDraft ?? '').trim();
    const enabled = trimmed.length > 0;

    return useMutation({
        mutationFn: ordersRecognitionApi.deleteOrder,
        onSuccess: async (res, deletedId) => {
            if (res?.data?.status === 'success') {
                if (enabled) {
                    await queryClient.invalidateQueries({
                        queryKey: ordersRecognitionApi.getOrdersRecognitionSearchQueryOptions({
                            queryString: trimmed,
                        }).queryKey,
                    });

                    queryClient.setQueryData(
                        ordersRecognitionApi.getOrdersRecognitionListQueryOptions().queryKey,
                        (prev) => {
                            if (!prev?.data) return prev;

                            const prevList = prev.data.data ?? [];

                            return {
                                ...prev,
                                data: {
                                    ...prev.data,
                                    data: prevList.filter(
                                        (item) => String(item.id) !== String(deletedId)
                                    ),
                                },
                            };
                        }
                    );
                } else {
                    await queryClient.invalidateQueries({
                        queryKey:
                            ordersRecognitionApi.getOrdersRecognitionListQueryOptions().queryKey,
                    });
                }
                onSuccessCb?.();
            }
        },
    });
};
